import * as types from './constants';

// Get Assignment
export const getAssignmentRequest = data => (
  { type: types.GET_ASSIGNMENT_REQUEST, payload: data }
);

export const getAssignmentDone = data => (
  { type: types.GET_ASSIGNMENT_DONE, payload: data }
);

export const getAssignmentFailed = errors => (
  { type: types.GET_ASSIGNMENT_FAILED, payload: errors }
);